import React from 'react';
import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import {
  StaggerCss,
  TitleSection,
  getNinePointLayoutProperties,
} from '@mentimeter/question-modules-shared';
import { Box } from '@mentimeter/ragnar-ui/box';
import { ImageProgressive } from '@mentimeter/ragnar-ui/image-progressive';
import { PlaceholderImage } from './PlaceholderImage';

export function ImagePresentation() {
  const { useQuestion, useConfig } = usePresentationContext();

  const {
    question,
    question_styled,
    cropped_image_url,
    title_meta,
    slide_image_type,
    image_alt_description,
  } = useQuestion();
  const { enableAnimations } = useConfig();

  //Image does not have layout, so using default settings
  const { textAlign, justifyContent, alignItems } =
    getNinePointLayoutProperties(undefined);

  return (
    <Box
      width="100%"
      flex={1}
      data-testid="image-container"
      alignItems={alignItems}
      justifyContent={justifyContent}
    >
      <StaggerCss index={1} type="fade" enableAnimations={enableAnimations}>
        <Box
          flex="1 1 auto"
          width="100%"
          alignItems="center"
          justifyContent="center"
          mb={question || title_meta ? 3 : 0}
        >
          <Box height="100%" width="100%" position="absolute" top={0} left={0}>
            {slide_image_type === 'image-frame' &&
              (cropped_image_url ? (
                <ImageProgressive
                  src={cropped_image_url}
                  alt={image_alt_description || question}
                  stretch
                />
              ) : (
                <PlaceholderImage />
              ))}
          </Box>
        </Box>
      </StaggerCss>
      <TitleSection
        enablePlaceholderAlignment
        alignItems={alignItems}
        textAlign={textAlign}
        title={question}
        styledTitle={question_styled}
        label={title_meta}
        fontSizeOffset={undefined}
        mb="space0"
        placeholder="Add your caption here..."
        showTextSizeDropdown={false}
      />
    </Box>
  );
}
